<template>
	<div class="container-fluid">
		<card>
			<book-debts :book="sheet">
				<slot>
					<div v-i18n="'anonymous_nodebts'"></div>
				</slot>
			</book-debts>
		</card>
	</div>
</template>

<script>
	import BookDebts from 'ui/book-debts.vue';
	import Card from 'ui/widgets/card.vue';
	import store from 'core/store';

	export default {
		components: {
			BookDebts,
			Card
		},

		data() {
			return {
				sheet: store.globals.sheet
			};
		}
	}
</script>


// WEBPACK FOOTER //
// src/apps/anonymous/debts.vue